import { PageHeader } from '@/components';
import { PageContent } from '@/components';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { UpdatePasswordContent } from '../_components/UpdatePasswordContent';

const UpdatePasswordPage: FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <PageHeader
        title={t('change-password-page')}
        breadcrumbs={[
          { title: t('user-profile-page'), href: '/profile' },
          {
            title: t('change-password-page'),
          },
        ]}
      />
      <PageContent>
        <UpdatePasswordContent />
      </PageContent>
    </>
  );
};

export default UpdatePasswordPage;
